import { ReactNode, use } from "react";

import { NavigationContext } from "lib/navigation/use-navigation";
import { usePaths } from "lib/navigation/use-paths";
import { ContentNode } from "lib/types";

interface LinkProps {
  node: ContentNode;
  children: ReactNode;
}

export function Link({ node, children, ...props }: LinkProps) {
  const { updateBookmark } = use(NavigationContext)!;
  const { indexToXpointer } = usePaths();

  if (node.hr) {
    return (
      <a
        {...props}
        href="#"
        onClick={e => {
          e.preventDefault();
          const targetXpointer = indexToXpointer(Number(node.hr));

          if (targetXpointer) {
            updateBookmark(targetXpointer);
          }
        }}
      >
        {children}
      </a>
    );
  }

  return (
    <a {...props} href={node.href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
